//@vendor
const PropTypes = require('prop-types');
const React = require('react');
const moment = require('moment');
//@commons
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');
//@constants
const {
    DATE_FILTER_NONE,
    DEFAULT_NOTIFICATION_LIST_FROM,
    DEFAULT_NOTIFICATION_LIST_FROM_UNIT
} = require('constants/index');

class UserNotificationsSectionFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immFilters } = props;

        this.state = {
            dateFrom: immFilters.getIn(['date','from']),
            dateSelected: immFilters.getIn(['date','selected']),
            dateTo: immFilters.getIn(['date','to'])
        };

        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    }

    handleOnSubmit(event) {
        event.preventDefault();
        const {
            dateFrom,
            dateSelected,
            dateTo
        } = this.state;

        this.props.setFilters({
            date: {
                isActive: dateSelected !== DATE_FILTER_NONE,
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            }
        });
    }

    render() {
        const { immFilters, isOpen, onCloseClick } = this.props;
        const minDateAllowed = moment().startOf('day').subtract(DEFAULT_NOTIFICATION_LIST_FROM, DEFAULT_NOTIFICATION_LIST_FROM_UNIT);

        const content = (
            <DateFilter
                immFilter={immFilters.get("date")}
                minDate={minDateAllowed}
                onChangeMax={this.handleChangeDateMax}
                onChangeMin={this.handleChangeDateMin}
                onChangeSelected={this.handleChangeDateSelected}
                showAnnual={false}
            />
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={isOpen}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleOnSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="userNotificationsSectionFilter-filterNotifications"
            />
        );
    }
}

UserNotificationsSectionFilter.propTypes = {
    immFilters: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired
};

module.exports = UserNotificationsSectionFilter;
